import { useEffect } from 'react';
import { SUBAWARDEE_INFO } from '../config/initiativeLeadsMapping';
import { useGroup } from '../contexts/GroupContext';

function isKnownSubawardee(id: string | null): id is string {
  return id != null && SUBAWARDEE_INFO.some((s) => s.id === id);
}

/**
 * Keeps `selectedGroup` / localStorage (and thus default `X-Selected-Group` on httpClient)
 * aligned with the admin "Filter by Subawardee" value so non-scoped API calls match the filter.
 */
export function useSyncSelectedGroupFromSubawardee(subawardee: string | null): void {
  const { setSelectedGroup, isGroupAccessible } = useGroup();

  useEffect(() => {
    if (!isKnownSubawardee(subawardee)) return;
    if (!isGroupAccessible(subawardee)) return;
    setSelectedGroup(subawardee);
  }, [subawardee, setSelectedGroup, isGroupAccessible]);
}
